/**
 * PURPOSE: Mostrar el detalle expandible de una notificación administrativa.
 * RESPONSIBILITIES: Presentar contexto del partido o entrenamiento y valores anteriores/actuales de forma organizada.
 * COLLABORATORS: AuditNotificationPanel.jsx y auditDisplay.utils.js.
 * ROUTE: winscore/src/components/global/AuditNotificationPanel/AuditNotificationDetails.jsx
 */
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import {
  FIELD_LABELS,
  formatAuditValue,
  getAuditContextSubtitle,
  getAuditContextTitle,
  getTrainingSnapshot,
} from "./auditDisplay.utils.js";

const TrainingDetails = ({ item }) => {
  const snapshot = getTrainingSnapshot(item);
  const rows = [
    ["Institución", snapshot?.institution?.name],
    ["Fecha", snapshot?.date],
    ["Inicio", snapshot?.startTime],
    ["Fin", snapshot?.endTime],
    ["Sede", snapshot?.venue?.name],
    ["Notas", snapshot?.notes],
  ].filter(([, value]) => value !== null && value !== undefined && value !== "");

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {rows.map(([label, value]) => (
        <div key={label} className="rounded-xl bg-gray-50 p-3 dark:bg-gray-800">
          <p className="text-xs font-black uppercase text-gray-500">{label}</p>
          <p className="mt-1 text-sm font-bold text-gray-900 dark:text-white">{String(value)}</p>
        </div>
      ))}
    </div>
  );
};

const ChangeDetails = ({ item }) => (
  <div className="grid gap-2 sm:grid-cols-2">
    {(item.changedFields || []).map((field) => (
      <div key={field} className="rounded-xl bg-gray-50 p-3 dark:bg-gray-800">
        <p className="text-xs font-black uppercase text-gray-500">{FIELD_LABELS[field] || field}</p>
        <p className="mt-1 text-xs text-gray-500">Anterior: {formatAuditValue(item.before?.[field], field)}</p>
        <p className="text-sm font-bold text-gray-900 dark:text-white">Actual: {formatAuditValue(item.after?.[field], field)}</p>
      </div>
    ))}
  </div>
);

export function AuditNotificationDetails({ item }) {
  const [open, setOpen] = useState(false);
  const title = getAuditContextTitle(item);
  const subtitle = getAuditContextSubtitle(item);

  return (
    <div className="mt-3">
      <div className="rounded-xl border border-gray-100 bg-white px-3 py-2 dark:border-gray-700 dark:bg-gray-900">
        <p className="font-black text-gray-900 dark:text-white">{title}</p>
        {subtitle ? <p className="mt-0.5 text-xs font-semibold text-gray-500">{subtitle}</p> : null}
      </div>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="mt-2 inline-flex items-center gap-2 text-sm font-black text-blue-600 transition hover:text-blue-800"
      >
        {open ? <FaChevronUp /> : <FaChevronDown />}
        {open ? "Ocultar detalles" : "Ver detalles"}
      </button>
      {open ? (
        <div className="mt-3 grid gap-3">
          {item.entityType === "training" ? <TrainingDetails item={item} /> : null}
          {(item.changedFields || []).length ? <ChangeDetails item={item} /> : null}
          {item.entityType === "training" && item.action === "delete" ? (
            <p className="text-xs font-semibold text-gray-500">La información corresponde al entrenamiento antes de eliminarlo.</p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
